import { render, staticRenderFns } from "./AdjustDetails.vue?vue&type=template&id=53b85fd4&"
import script from "./AdjustDetails.vue?vue&type=script&lang=js&"
export * from "./AdjustDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdjustDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports